<template>
    <div class="diagram-all-record-panel" @click="clickAllPanel">
        <div class="diagarm-a-r-p-top"></div>
        <div class="diagarm-a-r-p-content">
            <div class="diagram-a-r-p-list">
                <div class="diagram-a-r-p-item" v-for="(rText, rIndex) in recordAllList" :key="rText" :class="{'cur': diagramAllRecordOrder == rIndex}" @click="clickAllItem(rIndex)">{{rText+'('+(rIndex == 0 ? diagramRecordList.length : rIndex == 1 ? diagramRecordList.filter((el) => {return el.hasFb}).length : rIndex==2 ? diagramRecordList.filter((el) => {return !el.hasFb}).length : diagramRecordList.filter((el) => {return el.f_type+2==rIndex}).length)+')'}}<i class="iconfont icon-selected" v-if="diagramAllRecordOrder == rIndex"></i></div>
            </div>
        </div>
        <div class="diagarm-a-r-p-bottom"></div>
    </div>
</template>


<script>
import * as consts from '../../modules/data/base/consts'
export default {
    name: 'DiagramRecordAllPanel',
    components: {},
    computed: {
        diagramRecordList() {
            return this.$store.state.diagram.diagramRecordList;
        },
        diagramAllRecordOrder() {
            return this.$store.state.diagram.diagramAllRecordOrder;
        },
        diagramAllRecordList() {
            return this.$store.state.diagram.diagramAllRecordList;
        }
    },
    data() {
        return {
            recordAllList: consts.CONST_DIAGRAM_RECORD_ALL_LIST
        }
    },
    methods:{
        clickAllPanel() {
            this.$store.state.diagram.showAllPanel = false;
        },
        clickAllItem(index) {
            this.$store.dispatch('diagram/filterAllRecordByType', index);
        }
    }
}
</script>